const indexItems = [
  { title: '国产剧', count: '2,856部', desc: '古装、都市、悬疑、军旅，国产好剧一网打尽', color: 'bg-primary-100 text-primary-700' },
  { title: '美剧', count: '1,942部', desc: '最新美剧同步更新，经典老剧全季收录', color: 'bg-accent-100 text-accent-700' },
  { title: '韩剧', count: '1,528部', desc: '热播韩剧实时追踪，高分经典一应俱全', color: 'bg-primary-100 text-primary-700' },
  { title: '日剧', count: '1,203部', desc: '日剧黄金档同步，小众佳作深度挖掘', color: 'bg-accent-100 text-accent-700' },
  { title: '动漫', count: '2,314部', desc: '日漫国漫全覆盖，新番老番随心切换', color: 'bg-primary-100 text-primary-700' },
  { title: '综艺', count: '986部', desc: '国内外热门综艺，欢笑与感动全收录', color: 'bg-accent-100 text-accent-700' },
  { title: '电影', count: '3,427部', desc: '院线大片高清上线，经典佳作随时重温', color: 'bg-primary-100 text-primary-700' },
  { title: '纪录片', count: '672部', desc: '自然、历史、科技、人文，打开认知新世界', color: 'bg-accent-100 text-accent-700' },
];

export default function IndexSection() {
  return (
    <section
      id="index"
      className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50 scroll-mt-16"
    >
      <div className="max-w-6xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center">
          剧集索引
        </h2>
        <div className="mt-2 w-12 h-1 bg-primary-500 mx-auto rounded-full"></div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexItems.map((item) => (
            <div
              key={item.title}
              className="group p-5 rounded-lg bg-background-100 hover:bg-background-200/70 transition-colors cursor-pointer flex flex-col"
            >
              <div className="flex items-center justify-between">
                <h3 className="font-heading text-lg font-semibold text-foreground-900">{item.title}</h3>
                <span className={`px-2 py-0.5 text-xs font-medium rounded-full whitespace-nowrap ${item.color}`}>
                  {item.count}
                </span>
              </div>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              <div className="mt-3 flex items-center gap-1 text-sm text-primary-500 group-hover:gap-2 transition-all">
                <span className="whitespace-nowrap">浏览全部</span>
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}